import { FC, useEffect, useState, ReactElement } from "react";
import "./newCheckout.css";
import { Header } from "../../components/Header";
import { ConfigType, PluginconfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useOrder } from "../../hooks/useOrder";
import {
  FrenetDeliveryMethodType,
  OrderType,
  ProductType,
  SellerInfo,
} from "../../contexts/OrderContext";
import { ProductItem } from "../../components/newCheckoutProductItem/ProductItem";
import { ChooseAddress } from "../../components/chooseAddress/chooseAddress";
import { CupomInput } from "../../components/CupomInput/cupomInput";
import { CashbackInput } from "../../components/CashbackInput/cashbackInput";
import { CashbackEarnPreview } from "../../components/CashbackEarnPreview/cashbackEarnPreview";
import { ResumeCart } from "../../components/resumeCart/resumeCart";
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { LocationType } from "../../contexts/PluginspaceContext";
import { useSeller } from "../../hooks/useSeller";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import Swal from "sweetalert2";
import { cepNoMask, cpfCnpjNoMask } from "../../functions/mask";
import { floatToPrice } from "../../functions/price_functions";
import { Menu } from "../../components/Menu";
import { ButtonCheckout } from "../../components/buttonCheckout/ButtonCheckout";
import moment from "moment";
/*Toast */
import "react-toastify/dist/ReactToastify.css";
import { useToast } from "../../hooks/useToast";
import { AddressMapType } from "../../components/ModalDelivery";
import { useDiscount } from "../../hooks/useDiscount";
import EmptyState from "../../components/EmptyStates/EmptyState";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";
import SellerCodeInput from "../../components/SellerCodeInput/SellerCodeInput";
import { NO_VALUE_SELLER_DISCOUNT } from "../Catalog/auxCatalog";
import { useSellerInfo } from "../../contexts/sellerInfoContext";
import { cepHelper } from "./factory/cepHelper";
import {
  validateDiscoutCoupon,
  validateCartToCupom,
  calculateNinegridDiscount as calculateNinegridDiscountEngine,
  calculateTotvsDiscount,
} from "./factory/cupomDiscountHelper";
import {
  ItemEmptyType,
  MapLocationType,
  NinegridMotorConfig,
  ProductCartType,
  ProductTotvsType,
  StoresType,
} from "./newCheckout.type";
import useCart from "../../contexts/cartContext/cartContext";
import { removeCouponFromProducts } from "./factory/mappers";
import { useCustomer } from "../../contexts/customerContext/customerContext";
import { Address } from "../../contexts/customerContext/customerType";
import { Product } from "../../contexts/cartContext/cartType";
import { Discount } from "../../contexts/discountContext/discount.type";
import { useCashbackRedeem } from "../../hooks/useCashbackRedeem";
import { useCashbackEarn } from "../../hooks/useCashbackEarn";
import { removeCashbackFromProducts } from "./factory/cashbackHelper";

const NewCart: FC = (): ReactElement => {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const { trackInitiateCheckout } = useFaceBookPixel();
  const {
    setCpfVendorByLink,
    setUpdateCustomerCart,
    setDiscountValue,
    setSellerInfo,
    clearSellerInfo,
    updateCustomerCart,
    sellerInfo,
  } = useSellerInfo();
  const {
    getToken,
    pluginspaceData,
    registerAccess,
    getThisPluginspace,
    getLocations,
  } = usePluginspace();
  /*Novos Helpers */
  const { validCep, verifyFrenet, findCepDeveryAndValue, getStoresByCep } =
    cepHelper();
  const {
    products,
    updateCartWithProducts,
    subtotalWithDiscount,
    setFreightCost,
    guidCart,
    addGuidCart,
  } = useCart();
  const { setCustomer, setCustomerAddress, customer } = useCustomer();

  const toastComponent = useToast();
  const [config, setConfig] = useState<ConfigType | void>();
  const { getAppConfig } = useAppConfig();
  const {
    applyDiscount,
    discounts,
    removeCashback,
    removeCoupon,
    hasDiscount,
  } = useDiscount();
  const [totvsVarejoAble, setTotvsVarejoAble] = useState(false);
  const [totvsMotorAble, setTotvsMotorAble] = useState(false);
  const [totvsChecked, setTotvsChecked] = useState(false);

  // Com TOTVS (105) able, não permite resgate/ganho/cálculo de cashback
  const cashbackAllowed = totvsChecked && !totvsVarejoAble;

  const {
    shouldShowCashback,
    availableBalance,
    redeemValue,
    setRedeemValue,
    hasCashback,
    appliedAmount,
    loading: loadingCashback,
    walletLoading,
    applyCashbackRedeem,
    clearCashbackRedeem,
    reapplyCashbackRedeem,
  } = useCashbackRedeem({ enabled: cashbackAllowed });
  const {
    shouldShowEarn,
    earnAmount,
    loading: loadingEarn,
  } = useCashbackEarn({ enabled: cashbackAllowed });
  const [loading, setLoading] = useState(true);
  const [loadingHeader, setLoadingHeader] = useState(true);
  // const orderContext = useOrder();
  const [calculatingDiscount, setCalculatingDiscount] = useState(false);
  const [coupon, setCoupon] = useState(localStorage.getItem(`cupom`) || "");
  const [hasCoupon, setHasCoupon] = useState(false);
  const [monetaryDiscountMax, setMonetaryDiscountMax] = useState(0);
  const [percentyDiscountMax, setPercentyDiscountMax] = useState(0);
  const [frenetMethods, setFrenetMethods] = useState<
    FrenetDeliveryMethodType[]
  >([]);
  const [defaultDeep, setDefaultDeep] = useState(0);
  const [defaultHeight, setDefaultHeight] = useState(0);
  const [defaultWeight, setDefaultWeight] = useState(0);
  const [defaultWidth, setDefaultWidth] = useState(0);

  /*Variaveis do Pedido */
  const [order, setOrder] = useState<OrderType>();
  const [productStores, setProductStores] = useState<Array<StoresType>>([]);
  /*Variaveis de entrega/retirada */
  const [freightFind, setFreightFind] = useState(0);
  const [typeFreight, setTypeFreight] = useState("withdraw");

  const [stores, setStores] = useState<Array<StoresType>>([]);

  /*Valores do CEP */
  const [cep, setCep] = useState("");
  const [findCep, setFindCep] = useState(false);
  const [valueCep, setValueCep] = useState(0);
  const [validShift, setValidShift] = useState(true);
  const [canWithdraw, setCanWithdraw] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  /* */
  const [locations, setLocations] = useState<Array<LocationType>>([]);
  const { getTokenSeller } = useSeller();

  const [ninegridMotorAble, setNinegridMotorAble] = useState(false);
  const [ninegridMotorConfig, setNinegridMotorConfig] =
    useState<NinegridMotorConfig>();

  const [valueWithDraw, setValueWithDraw] = useState(0);
  const [sellerCodeAble, setSellerCodeAble] = useState(false);

  const [minimumValue, setMinimumValue] = useState(0);

  /** Desconto */
  //Tipo de Desconto Geral ou Vendedor
  const [geralDiscount, setGeralDiscount] = useState(false);

  /**PluginsPceType */
  const [typePluginspace, setTypePluginspace] = useState("");

  /* Variaveis para o Toast */
  //const toast = useToast()

  const [addressMapLocation, setAddressMapLocation] =
    useState<AddressMapType | null>(null);
  const [position, setPosition] = useState({ latitude: 0, longitude: 0 });

  /* Seller Code */
  const [sellerCode, setSellerCode] = useState("");

  async function removeSellerCode() {
    setSellerCode("");
    clearSellerInfo();
  }

  const getUserPosition = async () => {
    try {
      setLoading(true);
      navigator.geolocation.getCurrentPosition(
        async (positionGet) => {
          setPosition({
            latitude: positionGet.coords.latitude,
            longitude: positionGet.coords.longitude,
          });
          await api
            .post(
              `/api/maps/cep-by-geolocation`,
              {
                latitude: positionGet.coords.latitude,
                longitude: positionGet.coords.longitude,
              },
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              },
            )
            .then(async (response) => {
              if (
                response.data &&
                response.data.success &&
                response.data.data &&
                response.data.data.length > 0
              ) {
                setCep(response.data.data[0].cep);
                setAddressMapLocation({
                  cep: response.data.data[0].cep,
                  city: response.data.data[0].city,
                  street: response.data.data[0].street,
                  district: response.data.data[0].district,
                  streetNumber: response.data.data[0].streetNumber,
                  state: response.data.data[0].state,
                  latLng: {
                    latitude: positionGet.coords.latitude,
                    longitude: positionGet.coords.longitude,
                  },
                });

                await getStores(response.data.data[0].cep, {
                  latitude: positionGet.coords.latitude,
                  longitude: positionGet.coords.longitude,
                });
                if (typeFreight === "delivery" && valueCep) {
                  setFreightFind(valueCep);
                }
              } else {
                toastComponent.openToast(
                  "error",
                  `Impossível recuperar localização do usuário`,
                  5000,
                );
              }
            })
            .catch((e) => {
              setLoading(false);
              toastComponent.openToast(
                "error",
                `Impossível recuperar localização do usuário`,
                5000,
              );
            });
        },
        () => {
          setLoading(false);
          toastComponent.openToast(
            "warning",
            `É necessário ativar a localização para usá-la`,
            5000,
          );
        },
      );
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  async function getConfig() {
    setLoadingHeader(true);
    const conf = await getAppConfig();

    if (conf) {
      const value = conf!.content.pdv.withDrawFee
        ? parseFloat(conf!.content.pdv.withDrawFee.toString())
        : 0;

      setMinimumValue(
        conf.content.pdv.minimumValue ? conf.content.pdv.minimumValue : 0,
      );
      setValueWithDraw(value);
      setFreightFind(value);

      setSellerCodeAble(conf.content.pdv.sellerCode);
    }

    setLoadingHeader(false);

    setConfig(conf);
    return conf;
  }

  async function getVerifyShift() {
    try {
      const pgData = await getThisPluginspace();
      const response = await api.post(
        `api/location-operation/verify`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      );
      if (pgData && pgData.type === "food") {
        setValidShift(response.data && response.data.success);
      } else {
        setValidShift(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function verifyTotvs() {
    try {
      const response = await api.post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 105,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      );

      if (response.data.data.length > 0) {
        const configData: PluginconfigType = response.data.data[0];

        if (configData.content.able === "1") {
          setTotvsVarejoAble(true);
          if (configData.content.habilitarMotorPromocao === "1") {
            setTotvsMotorAble(true);
            const productsCart = products.map((product) => {
              product.promotionalPrice = product.unitPrice;
              return product;
            });
            updateCartWithProducts(productsCart);
          }
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setTotvsChecked(true);
    }
  }

  //verificação do motor de promoção ninegrid
  async function verifyNinegridProm() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 107,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];
          if (configData.content.able === "1") {
            setNinegridMotorAble(true);
            setNinegridMotorConfig(configData.content);

            setGeralDiscount(
              configData.content.typeDiscount == 0 ? true : false,
            );

            setMonetaryDiscountMax(parseFloat(configData.content.maxMonetary));
            setPercentyDiscountMax(
              parseFloat(configData.content.maxPercentage),
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function validateCart(timeCart: string): Promise<{
    valid: boolean;
    msg: string;
  }> {
    try {
      let valid = false;
      const configLocal = await getAppConfig();
      const pg = await getThisPluginspace();

      const gtmValue =
        !pg || !pg?.gmt?.split(":")[0] ? -3 : parseInt(pg.gmt.split(":")[0]);

      const carrinhoDataCriacao = moment
        .utc(timeCart)
        .utcOffset(gtmValue)
        .seconds(0);
      const now = moment().utcOffset(gtmValue).seconds(0); // Data e hora atuais ajustadas para o GMT

      const hour = configLocal
        ? configLocal.content.pdv.sellerCartExpirationTime.split(":")[0]
        : "2";
      const minute = configLocal
        ? configLocal?.content.pdv.sellerCartExpirationTime.split(":")[1]
        : "0";

      const validTimeCart = carrinhoDataCriacao
        .clone()
        .add(parseInt(hour), "hours")
        .add(parseInt(minute), "minutes");

      valid = validTimeCart.isAfter(now) || validTimeCart.isSame(now, "second");
      const timeDifference = now.diff(validTimeCart, "minutes");
      const hours = Math.floor(timeDifference / 60);
      const minutes = timeDifference % 60;

      let msg = "";

      if (hours && minutes) {
        msg += `${hours} hora(s) e ${minutes} minuto(s) `;
      } else if (minutes) {
        msg += `${minutes} minuto(s) `;
      }

      return {
        valid: valid,
        msg: msg,
      };
    } catch (er) {
      return {
        valid: false,
        msg: ``,
      };
    }
  }

  async function getCart(guid: string) {
    await api
      .get(`/api/customerCart/guid/${guid}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const order = response.data.data[0];

        const isValid = await validateCart(order.created);
        if (!isValid || !isValid.valid) {
          let text =
            "O carrinho do vendedor está expirado. Favor entrar em contato com o seu vendedor";
          if (isValid && isValid.msg) {
            text = `O tempo limite do carrinho expirou após ${isValid.msg}. Por favor, entre em contato com o vendedor`;
          }

          Swal.fire({
            icon: "warning",
            titleText: "Carrinho expirado",
            text: text,
          }).then(() => navigate(`/${pluginspace_id}/category`));
          return;
        }

        if (order.status != "open") {
          Swal.fire({
            icon: "warning",
            titleText: "Carrinho já utilizado",
            text: "O carrinho do vendedor já foi utilizado. Favor entrar em contato com o seu vendedor",
          });
          return;
        }

        if (order && order.cpfSeller) {
          setCpfVendorByLink(order.cpfSeller);
        }
        setCustomer({
          id: "0",
          email: "",
          name: order.customerName,
          phone: order.phoneCustomer,
          cpf: order.cpfCustomer,
        });

        addGuidCart(guid);

        let productsCart: any = [];

        if (order.jsonCart.products) {
          productsCart = order.jsonCart.products.map(
            (product: ProductCartType) => {
              const variationFormated: any = {};
              product.variation.map((variation: any) => {
                variationFormated[variation.grid] = variation.value
                  ? variation.value
                  : variation.valor;
              });
              const newProduct: ProductType = {
                id: product.id,
                image: product.img,
                code: product.code,
                locationId: order.locationId,
                name: product.name,
                promotionalPrice: product.promotional_price,
                quantity: product.quantity,
                sku: product.sku,
                stock: product.sku_info[0].inventory,
                unitPrice: product.unitPrice,
                variation: variationFormated,
                pluginspaceHash: pluginspace_id ? pluginspace_id : "",
                outStock: false,
                measures: product.sku_info[0].measures
                  ? product.sku_info[0].measures
                  : null,
              };
              return newProduct;
            },
          );
        } else {
          productsCart = order.jsonCart.map((product: ProductCartType) => {
            const variationFormated: any = {};
            product.variation.map((variation: any) => {
              variationFormated[variation.grid] = variation.value
                ? variation.value
                : variation.valor;
            });
            const newProduct: ProductType = {
              id: product.id,
              image: product.img,
              code: product.code,
              locationId: order.locationId,
              name: product.name,
              promotionalPrice: product.promotional_price,
              quantity: product.quantity,
              sku: product.sku,
              stock: product.sku_info[0].inventory,
              unitPrice: product.unitPrice,
              variation: variationFormated,
              pluginspaceHash: pluginspace_id ? pluginspace_id : "",
              outStock: false,
              measures: product.sku_info[0].measures
                ? product.sku_info[0].measures
                : null,
            };
            return newProduct;
          });
        }

        updateCartWithProducts(productsCart);

        setUpdateCustomerCart(true);
      })

      .catch((err) => {
        console.log(err);
      });
  }

  async function findCustomer(cpfOrCnpj: string) {
    const cpfWithouthMask = cpfCnpjNoMask(cpfOrCnpj);

    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const customerAddresses = response.data.data[0].customerAddresses;
          if (customerAddresses.length > 0) {
            setCep(customerAddresses[0].zipCode);
            const customerAddress: Address = {
              cep: customerAddresses[0].zipCode,
              street: "",
              number: "",
              neighborhood: "",
              city: "",
              state: "",
            };

            setCustomerAddress(customerAddress);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadAll() {
    setLoading(true);
    let config;
    const tk = getTokenSeller();
    if (tk && tk.profile == "seller") {
      navigate(`/${pluginspace_id}/cart`);
    } else {
      config = await getConfig();
    }

    await getVerifyShift();
    await verifyTotvs();
    await verifyNinegridProm();
    await validadeIfCupomExist();

    if (sellerCodeAble && sellerInfo.id && sellerInfo.sellerCode) {
      setSellerCode(sellerInfo.sellerCode);
      await findVendorByCode(sellerInfo.sellerCode);
    }

    const loc = await getLocations();

    setLocations(loc);

    const pgData = await getThisPluginspace();
    if (pgData && pgData.type) {
      setTypePluginspace(pgData.type);
    }

    if (window.location.search && window.location.search !== "") {
      const guidCart = window.location.search.split("=")[1];
      await getCart(guidCart);
      if (customer?.cpf) await findCustomer(customer.cpf);
    }

    setLoading(false);
  }

  async function getConfigFrenet() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 119,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then((res) => {
        const config = res.data.data.filter(
          (el: any) =>
            el.content?.deep &&
            el.content?.height &&
            el.content?.weight &&
            el.content?.width,
        );
        if (config.length > 0) {
          setDefaultDeep(config[0].content.deep);
          setDefaultHeight(config[0].content.height);
          setDefaultWeight(config[0].content.weight);
          setDefaultWidth(config[0].content.width);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadAllData() {
    try {
      setLoading(true);
      await getConfig();
      registerAccess("cart");
      await loadAll();
      await getConfigFrenet();
      // await calculateNinegridDiscountOnPageInit(true, false)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  async function findCepDelivery(cepSended?: string, configuration?: any) {
    try {
      const noMaskCep = cepNoMask(cepSended ? cepSended : cep);
      const token = await getToken();

      setLoading(true);
      let frenetItems: FrenetDeliveryMethodType[] = [];
      if (noMaskCep) {
        frenetItems = await verifyFrenet(noMaskCep, order?.products, token, {
          defaultHeight: defaultHeight.toString(),
          defaultDeep: defaultDeep.toString(),
          defaultWeight: defaultWeight.toString(),
          defaultWidth: defaultWidth.toString(),
        });
        setFrenetMethods(frenetItems);
      }
      const isValidCep = await validCep(noMaskCep);

      if (!isValidCep && noMaskCep) {
        setLoading(false);
        setFreightFind(0);
        toastComponent.openToast("warning", `Informe um CEP válido`, 5000);
        return null;
      }

      if (config) {
        const value = config!.content.pdv.withDrawFee
          ? parseFloat(config!.content.pdv.withDrawFee.toString())
          : 0;

        setValueWithDraw(value);
        setFreightFind(value);
      }
      let urlSearchValid = "";
      switch (
        configuration
          ? configuration?.content.pdv.restrictCep
          : config?.content.pdv.restrictCep
      ) {
        case "cep":
          urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
          break;
        case "area":
          urlSearchValid = `/api/delivery/valid/${noMaskCep}`;
          break;
        case "mapa":
          urlSearchValid = `/api/delivery-area/valid/${noMaskCep}`;
          break;
        default:
          urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
          break;
      }

      const { success, data } = await findCepDeveryAndValue(
        token,
        urlSearchValid,
      );
      const { findCep, valueCep, canWithdraw } = data;

      if (!success && (!frenetItems || !frenetItems.length)) {
        toastComponent.openToast(
          "warning",
          `Não foi possível encontrar formas de envio para o CEP`,
          5000,
        );
      }

      setFindCep(findCep);
      setValueCep(valueCep);
      setCanWithdraw(canWithdraw);

      setLoading(false);
    } catch (error) {
      console.error("findCepDelivery - Error: ", error);
      setLoading(false);
    }
  }

  /*Função usada para verificar se o cep é valido e se retorna */
  async function getStores(cepSended?: string, latLng?: MapLocationType) {
    try {
      setLoading(true);
      const token = await getToken();
      const cepUse = cepSended ? cepSended : cep;
      const noMaskCep = cepNoMask(cepUse);

      // Verificar se o CEP é válido
      const isValidCep = await validCep(noMaskCep);
      if (!isValidCep) {
        setLoading(false);
        toastComponent.openToast("warning", `Informe um CEP válido`, 5000);
        return;
      }
      const location =
        locations.find((el) => el.type == "internal")?.id.toString() || "";
      const storesRequest = await getStoresByCep(
        token,
        noMaskCep,
        config?.content.pdv.restrictCep || "cep",
        config && config.content.pdv.showOutStock ? true : false,
        location,
        latLng || null,
      );

      if (!storesRequest.success) {
        setLoading(false);
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text:
            storesRequest.emptyProducts &&
            storesRequest.emptyProducts.length > 0
              ? `Produtos: ${storesRequest.emptyProducts
                  .map((u: any) => u.name)
                  .join(", ")} sem estoque`
              : "Não foi possível encontrar formas de envio para o CEP.",
        });
        setStores([]);
        return;
      }
      setStores(storesRequest.data);
      setLoading(false);
      findCepDelivery(noMaskCep);
    } catch (error) {
      console.error("getStores - Error: ", error);
      setLoading(false);
    }
  }

  const verifyStock = async () => {
    setLoading(true);
    const locationType = locations.find((loc) => typeFreight === loc.code);
    let success = true;
    if (locationType && !(config && config.content.pdv.showOutStock)) {
      await api
        .post(
          `/api/variations/sku-inventory`,
          {
            skus: products.length > 0 ? products.map((p) => p.sku) : [],
            locationId: locationType.id,
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response) => {
          if (response.data && response.data.success && response.data.data) {
            const itemsSku = response.data.data.filter(
              (product: any) => product.inventory <= 0,
            );
            if (itemsSku.length > 0) {
              let skusEmpty = itemsSku.map((item: ItemEmptyType) => item.sku);
              const newProducts = products.map((produto) => {
                if (skusEmpty.includes(produto.sku)) produto.outStock = true;
                return produto;
              });
              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: `Produtos: ${itemsSku
                  .map((u: any) => u.name)
                  .join(", ")} sem estoque`,
              });
              updateCartWithProducts(newProducts);
              success = false;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Falha ao recuperar estoque de produtos`,
            });
            success = false;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: `Falha ao recuperar estoque de produtos`,
          });
          success = false;
        });
    }
    setLoading(false);
    return success;
  };

  const createCart = async () => {
    if (updateCustomerCart) {
      const link = `${window.location.origin}/${
        window.location.pathname.split("/")[1]
      }/cart`;

      if (guidCart) {
        //create
        const jsonCart = {
          products: products,
          address: {},
          type: typeFreight,
          freight: freightFind,
          totalDiscount: 0,
        };

        const objCustomerCart = {
          customerName: "",
          cpfCustomer: "",
          phoneCustomer: "",
          cpfSeller: sellerInfo.cpf,
          jsonCart: jsonCart,
          locationId: products[0].locationId,
          urlcart: link + "?cart=",
        };
        await api
          .post(`/api/customerCart`, objCustomerCart, {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          })
          .then(async (response) => {
            if (response.status === 201) {
              const data = response.data.dados;
              addGuidCart(data.guid);
            } else {
              setLoading(false);
              Swal.fire({
                icon: "error",
                title: "Erro ao criar carrinho",
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Erro ao criar carrinho",
            });
            console.log(err);
            setLoading(false);
          });

        return;
      }
    }
    return;
  };

  /**
   * Wrapper para calcular desconto do motor TOTVS
   * Chama o helper e atualiza CartContext
   */
  async function calculateDiscount() {
    try {
      if (totvsVarejoAble && coupon) {
        setLoading(true);
        setCalculatingDiscount(true);

        // Usar CartContext para pegar produtos
        let currentProducts = products;

        // Validar se carrinho é válido para cupom
        const cartIsValid = validateCartToCupom(currentProducts);

        if (!cartIsValid || !cartIsValid.success) {
          setCalculatingDiscount(false);
          setLoading(false);
          toastComponent.openToast("warning", cartIsValid.msg, 8000);
          return;
        }

        // Preserva cashback: remove só para calcular o cupom e reaplica depois
        const cashbackAmountToKeep =
          hasCashback || hasDiscount("cashback") ? appliedAmount : 0;
        if (cashbackAmountToKeep > 0) {
          currentProducts = removeCashbackFromProducts(currentProducts);
          removeCashback();
        }

        // Calcular desconto via motor TOTVS
        const token = await getToken();
        const discountResult = await calculateTotvsDiscount(
          coupon,
          currentProducts,
          api,
          token,
          pluginspaceData?.id,
        );

        if (!discountResult.success) {
          setCalculatingDiscount(false);
          setLoading(false);
          if (cashbackAmountToKeep > 0) {
            await reapplyCashbackRedeem(cashbackAmountToKeep, currentProducts);
          }
          toastComponent.openToast(
            "error",
            discountResult.errorMsg || "Cupom não foi aplicado",
            7000,
          );
          return;
        }

        // Atualizar CartContext com produtos descountados
        const { discountedProducts, totalDiscount } = discountResult;

        // Atualizar CartContext (persiste automaticamente em localStorage)
        updateCartWithProducts(discountedProducts);

        // Persistir cupom e desconto no DiscountContext
        const discountPayment: Discount = {
          type: "coupon",
          code: coupon,
          value: totalDiscount,
          appliedAt: new Date(),
        };
        applyDiscount(discountPayment);

        // Atualizar estado local
        setHasCoupon(true);

        if (cashbackAmountToKeep > 0) {
          await reapplyCashbackRedeem(cashbackAmountToKeep, discountedProducts);
        }

        toastComponent.openToast(
          "success",
          `O cupom de desconto ${coupon} foi aplicado`,
          5000,
        );

        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setCalculatingDiscount(false);
      setLoading(false);
      toastComponent.openToast("error", "Erro ao aplicar cupom", 5000);
    } finally {
      setCalculatingDiscount(false);
    }
  }

  useEffect(() => {
    loadAllData();
  }, []);

  async function chooseAddress() {
    if (subtotalWithDiscount < minimumValue) {
      toastComponent.openToast(
        "warning",
        `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue,
        )}`,
        5000,
      );

      return;
    }
    const locationType = locations.find((loc) => typeFreight === loc.code);
    if (locationType) {
      const storeOutStock: StoresType | undefined = productStores.find(
        (str) => str.locationId === locationType.id && str.currentBalance <= 0,
      );
      if (storeOutStock && !(config && config.content.pdv.showOutStock)) {
        const prodFinded: Product | undefined = products.find(
          (prod) => prod.sku === storeOutStock.sku,
        );
        if (prodFinded) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: `Produto: ${prodFinded.name} sem estoque`,
          });
          return;
        }
      }
    }
    setFreightCost(freightFind);
    navigate(`/${pluginspace_id}/new-customer`);
  }

  //funcao utilizada para validar se o cupom ja foi aplicado
  // anteriormente e se sim, realizar os bloqueios do front e ou demonstrar que existe um cupom.
  async function validadeIfCupomExist() {
    try {
      const cupom = discounts.find((discount) => discount.type === "coupon");
      if (cupom && cupom.code) {
        setCoupon(cupom.code);
        setHasCoupon(true);
      }
    } catch (error) {
      console.log(error);
      setHasCoupon(false);
    }
  }

  /**
   * Wrapper para calcular desconto do motor Ninegrid
   * Chama os helpers e atualiza CartContext
   */
  async function calculateNinegridDiscount(doNotShow?: boolean) {
    try {
      // Só entra no fluxo de cupom se houver código informado (evita limpar cashback no "Seguir com a Compra")
      if (ninegridMotorAble && coupon) {
        setLoading(true);
        setCalculatingDiscount(true);

        // Usar CartContext para pegar produtos
        let currentProducts = products;

        // Validar se carrinho é válido para cupom
        const cartIsValid = validateCartToCupom(currentProducts);

        if (!cartIsValid || !cartIsValid.success) {
          setCalculatingDiscount(false);
          setLoading(false);
          if (!doNotShow) {
            toastComponent.openToast("warning", cartIsValid.msg, 8000);
          }
          return;
        }

        // Validar cupom no servidor
        const token = await getToken();
        const couponIsValid = await validateDiscoutCoupon(
          coupon,
          api,
          token,
          doNotShow,
        );

        if (!couponIsValid || !couponIsValid.success) {
          setCalculatingDiscount(false);
          setLoading(false);
          if (!doNotShow && couponIsValid.errorMsg) {
            toastComponent.openToast("warning", couponIsValid.errorMsg, 5000);
          }
          return;
        }

        // Preserva cashback: remove só para calcular o cupom e reaplica depois
        const cashbackAmountToKeep =
          hasCashback || hasDiscount("cashback") ? appliedAmount : 0;
        if (cashbackAmountToKeep > 0) {
          currentProducts = removeCashbackFromProducts(currentProducts);
          removeCashback();
        }

        const couponData = couponIsValid.data.data[0];

        // Calcular desconto via motor Ninegrid
        const discountResult = await calculateNinegridDiscountEngine(
          couponData,
          currentProducts,
          api,
          token,
          pluginspaceData?.id,
        );

        if (!discountResult.success) {
          setCalculatingDiscount(false);
          setLoading(false);
          if (cashbackAmountToKeep > 0) {
            await reapplyCashbackRedeem(cashbackAmountToKeep, currentProducts);
          }
          if (!doNotShow) {
            toastComponent.openToast(
              "warning",
              discountResult.errorMsg || "Cupom não foi aplicado",
              7000,
            );
          }
          return;
        }

        // Atualizar CartContext com produtos descountados
        const { totalDiscount, discountedProducts } = discountResult;

        updateCartWithProducts(discountedProducts);

        // Persistir cupom e desconto no DiscountContext

        const discountPayment: Discount = {
          type: "coupon",
          code: couponData.nameCoupom,
          value: totalDiscount,
          appliedAt: new Date(),
        };
        applyDiscount(discountPayment);

        // Atualizar estado local
        setHasCoupon(true);

        if (cashbackAmountToKeep > 0) {
          await reapplyCashbackRedeem(cashbackAmountToKeep, discountedProducts);
        }

        if (!doNotShow) {
          toastComponent.openToast(
            "success",
            "Cupom utilizado com sucesso",
            7000,
          );
        }

        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setCalculatingDiscount(false);
      setLoading(false);
    }
  }

  /**
   * Wrapper para remover desconto
   * Chama helper e atualiza CartContext
   */
  async function removeDiscount() {
    try {
      setLoading(true);
      setCalculatingDiscount(true);

      // Preserva cashback ao remover só o cupom
      const cashbackAmountToKeep =
        hasCashback || hasDiscount("cashback") ? appliedAmount : 0;

      let currentProducts = products;
      if (cashbackAmountToKeep > 0) {
        currentProducts = removeCashbackFromProducts(currentProducts);
        removeCashback();
      }

      // Remover apenas o desconto de cupom dos produtos
      const cleanedProducts = removeCouponFromProducts(currentProducts);
      updateCartWithProducts(cleanedProducts);

      // Limpar apenas cupom (não clearAllDiscounts)
      setCoupon("");
      setHasCoupon(false);
      removeCoupon();

      if (cashbackAmountToKeep > 0) {
        await reapplyCashbackRedeem(cashbackAmountToKeep, cleanedProducts);
      }

      toastComponent.openToast("success", "Cupom removido com sucesso", 5000);

      setLoading(false);
    } catch (error) {
      console.error("Erro ao remover desconto:", error);
      setLoading(false);
    } finally {
      setCalculatingDiscount(false);
    }
  }

  function goToCategory() {
    navigate(`/${pluginspace_id}/category`);
  }

  async function findVendorByCode(code: string): Promise<any> {
    try {
      if (!code) {
        return;
      }

      setLoading(true);

      const discountValue = await getVendorInfoByCode(code);

      if (!discountValue.sellerInfo.id) {
        setSellerCode("");
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "Código de vendedor inválido",
        });
        return NO_VALUE_SELLER_DISCOUNT;
      }
      const sellerInfo = discountValue.sellerInfo;

      setCpfVendorByLink(sellerInfo.cpf);
      setUpdateCustomerCart(true);
      setDiscountValue(discountValue.discountValue);
      setSellerInfo(discountValue.sellerInfo);

      return discountValue;
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Erro!",
        text: "Falha ao buscar informações do vendedor",
      });
      return null;
    } finally {
      setLoading(false);
    }
  }

  async function getVendorInfoByCode(code: string): Promise<{
    discountValue: number;
    sellerInfo: SellerInfo;
  }> {
    return await api
      .post(
        `/api/users/filter`,
        {
          type: "seller",
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (res: any) => {
        if (res.data) {
          const sellerData = res.data.data.find(
            (e: any) => e.sellerCode === code.toString(),
          );

          if (sellerData) {
            const seller: SellerInfo = {
              cpf: sellerData.cpf,
              image: sellerData.image,
              email: sellerData.email,
              id: sellerData.id,
              name: sellerData.name,
              sellerCode: sellerData.sellerCode,
              numberPhone: sellerData.numberPhone,
              pluginspaceId: parseInt(sellerData.pluginspaceId),
            };
            return {
              discountValue: 0,
              sellerInfo: seller,
            };
          }
        }

        return NO_VALUE_SELLER_DISCOUNT;
      })
      .catch((err) => {
        console.log(err);
        return NO_VALUE_SELLER_DISCOUNT;
      });
  }

  return (
    <div className="newCheckout">
      <div className="newCheckout-content">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading || walletLoading ? (
          <div
            style={{
              width: "100%",
              height: `calc(${loadingHeader ? "100vh" : "100vh - 2em"})`,
            }}
          >
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="body">
            <div className="content">
              <div className="title">
                <h3>Carrinho de compras</h3>
              </div>
              {/* Mostrar Carrinho de compras do cliente */}
              {order && !order.products.length ? (
                <div className={"empty_product"}>
                  <EmptyState
                    type={"cart"}
                    textButton={"Procurar"}
                    colorIcon={
                      config?.webappcolor.iconsheader
                        ? config.webappcolor.iconsheader
                        : "#CEA127"
                    }
                    noShowBackground
                    action={goToCategory}
                  />
                </div>
              ) : (
                <>
                  <div className="carrinho-compras">
                    {products.map((prod) => (
                      <ProductItem
                        product={prod}
                        key={prod.id}
                        showOutStock={config?.content.pdv.showOutStock}
                        motorTotvs={false}
                        canChange={true}
                        hasCoupon={hasCoupon}
                        hasCashback={hasCashback}
                        omitGrid={config?.content?.pdv?.omitGrid}
                      />
                    ))}
                  </div>

                  {/* Escolha de entrega ou retirada */}
                  <ChooseAddress
                    deliveryActive={
                      config && config.content.pdv.internalDelivery
                        ? true
                        : false
                    }
                    findCep={findCep}
                    withDrawValue={valueWithDraw}
                    deliveryDrawValue={valueCep}
                    setCep={setCep}
                    cep={cep}
                    getStores={getStores}
                    findCepDelivery={findCepDelivery}
                    setTypeFreight={setTypeFreight}
                    setFreightFind={setFreightFind}
                    typeFreight={typeFreight}
                    stores={stores}
                    frenetMethods={frenetMethods}
                    findLocation={config?.content.pdv.ableUserLocation}
                    config={config}
                    getPosition={getUserPosition}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    selectValue={false}
                  />

                  {/* Cupom  totvs */}
                  {totvsVarejoAble && !ninegridMotorAble && (
                    <CupomInput
                      cupon={coupon}
                      setCupon={setCoupon}
                      hasCoupon={hasCoupon}
                      calcDiscount={calculateDiscount}
                      removeDiscount={removeDiscount}
                    />
                  )}

                  {/* Cupom  ninegrid */}
                  {ninegridMotorAble && !totvsVarejoAble && (
                    <CupomInput
                      cupon={coupon}
                      setCupon={setCoupon}
                      hasCoupon={hasCoupon}
                      calcDiscount={calculateNinegridDiscount}
                      removeDiscount={removeDiscount}
                    />
                  )}

                  {/* Prévia de cashback a ganhar */}
                  {cashbackAllowed && shouldShowEarn && (
                    <CashbackEarnPreview
                      amount={earnAmount}
                      loading={loadingEarn}
                    />
                  )}

                  {/* Cashback — só aparece se houver cliente e carteira ativa */}
                  {cashbackAllowed && shouldShowCashback && !hasCoupon && (
                    <CashbackInput
                      redeemValue={redeemValue}
                      setRedeemValue={setRedeemValue}
                      availableBalance={availableBalance}
                      hasCashback={hasCashback}
                      appliedAmount={appliedAmount}
                      loading={loadingCashback}
                      onApply={applyCashbackRedeem}
                      disabled={hasCoupon}
                      onRemove={() => clearCashbackRedeem()}
                    />
                  )}

                  {/* Coduigo do Vendedor  ninegrid */}
                  {sellerCodeAble && (
                    <SellerCodeInput
                      sellerCode={sellerCode}
                      setSellerCode={setSellerCode}
                      removeSellerCode={removeSellerCode}
                      findSeller={findVendorByCode}
                    />
                  )}

                  {/* Resumo */}
                  <ResumeCart />
                </>
              )}
            </div>
            {products.length > 0 && (
              <ButtonCheckout
                action={async () => {
                  if (!canWithdraw && typeFreight === "delivery" && cep) {
                    setFreightFind(0);
                    toastComponent.openToast(
                      "warning",
                      `Informe um CEP válido`,
                      5000,
                    );
                    return;
                  }
                  if (validShift) {
                    const successStock = await verifyStock();
                    if (successStock) {
                      localStorage.removeItem("qrcodePixPayment");
                      await createCart();
                      await calculateDiscount();
                      await calculateNinegridDiscount(true);
                      trackInitiateCheckout();
                      await chooseAddress();
                    }
                  }
                }}
                label={"Seguir com a Compra"}
                backgroundColor={
                  config?.webappcolor.webappbutton
                    ? config.webappcolor.webappbutton
                    : "#EAEAEA"
                }
                color={
                  config?.webappcolor.fontbutton
                    ? config?.webappcolor.fontbutton
                    : "#636363"
                }
                marginBottom
              />
            )}
          </div>
        )}

        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
};

export { NewCart };
